import { Alert, Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import { useAuth } from '../auth/AuthContext';

export function OAuthConsent() {
  const { appUser, signOut } = useAuth();
  const params = new URLSearchParams(window.location.search);
  const clientName = params.get('client_name') || params.get('client_id') || 'ChatGPT';
  const redirectUri = params.get('redirect_uri');

  const approve = () => {
    if (redirectUri) {
      const url = new URL(redirectUri);
      url.searchParams.set('courtcaptain_consent', 'approved');
      window.location.assign(url.toString());
      return;
    }
    window.history.replaceState({}, '', '/');
    window.location.reload();
  };

  return (
    <Box sx={{ maxWidth: 760, mx: 'auto', py: 4 }}>
      <Card>
        <CardContent>
          <Stack spacing={2.5}>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <SecurityIcon color="primary" />
              <Box>
                <Typography variant="h5" sx={{ fontWeight: 700 }}>Connect CourtCaptain AI</Typography>
                <Typography variant="body2" color="text.secondary">
                  Review the read-only access requested by {clientName}.
                </Typography>
              </Box>
            </Stack>
            <Alert severity="info">
              CourtCaptain uses Supabase Auth as the identity provider. This screen is a CourtCaptain consent checkpoint; it does not collect a separate password.
            </Alert>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>Signed in as</Typography>
              <Typography variant="body2">{appUser?.display_name || 'CourtCaptain user'}</Typography>
            </Box>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>Allowed in Phase 1</Typography>
              <Typography variant="body2" color="text.secondary">
                Read accessible teams, read your active CourtCaptain AI context, and set a transient active team for conversation context.
                Setting the active team does not change team data and does not grant access to teams you cannot already view.
              </Typography>
            </Box>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>Not allowed in Phase 1</Typography>
              <Typography variant="body2" color="text.secondary">
                Creating, editing, deleting, publishing, inviting, emailing, or otherwise changing CourtCaptain business data through MCP tools.
              </Typography>
            </Box>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="flex-end">
              <Button variant="outlined" onClick={() => void signOut()}>Cancel</Button>
              <Button variant="contained" onClick={approve}>Allow read-only AI access</Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
